/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import analyticsPlane from "../../../../assets/analytics/analytics-plane.png";
import analyticsPlaneDark from "../../../../assets/analytics/analytics-plane-dark.png";
import useLocales from "../../../../hooks/useLocales";
import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";
import useSettings from "../../../../hooks/useSettings";
import { useStateContext } from "../../../../contexts/ThemeContext";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const UpgradeAnalytics = () => {
  const { darkMode } = useSelector((state) => state.theme);

  const navigate = useNavigate();

  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveUpgradeAnalyticsPageNav } = useStateContext();

  const handleProAnalytics = () => {
    navigate("/pricing");
  };

  useEffect(() => {
    setActiveUpgradeAnalyticsPageNav(true);
    return () => {
      setActiveUpgradeAnalyticsPageNav(false);
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Analytics | Bil.Bio</title>
        <meta property="og:title" content="Analytics | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] overflow-y-auto">
        <div className="mx-[100px] mt-10">
          <h6 className="text text-heading_color dark:text-color_v1_dark text-custom_h5 ">
            {translate("user_analytics.analytics")}
          </h6>
          <p className="text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-color_v2_dark">
            {translate("user_analytics.some_states")}
          </p>
        </div>
        <div className="h-full flex items-center justify-between mx-[125px] ">
          <div>
            <div className="flex justify-end text-right">
              <img
                src={darkMode ? analyticsPlaneDark : analyticsPlane}
                alt="analytics plane"
                className="h-[260px] w-[260px] xl:h-[482px] xl:w-[482px] text-end xsmfold:block lg:hidden"
              />
            </div>
            <h5 className="text text-heading_color  text-custom_h6 dark:text-color_v1_dark">
              {/* {translate("")} */}
              {translate("user_analytics.feature_available")}
              <br />{" "}
              <span className="text-main_color">
                {translate("user_analytics.pro_user")}
              </span>
            </h5>
            <p className=" text-body_copy1 my-4 text-font_light_color dark:text-color_v2_dark">
              {translate("lorem_ipsum_dolor")}
            </p>
            <button
              onClick={() => handleProAnalytics()}
              className="rounded-full text-small2_b sm:text-body_copy2_black px-[26px] pt-[9px] pb-[8px] sm:px-10 sm:py-4 sm:pt-[17px] text-white bg-main_color"
            >
              {/* {translate("")} */}
              {translate("user_analytics.upgrade")}
            </button>
          </div>
          <img
            src={darkMode ? analyticsPlaneDark : analyticsPlane}
            alt="analytics plane"
            className="h-[260px] w-[260px] xl:h-[482px] xl:w-[482px] xsmfold:hidden lg:block"
          />
        </div>
      </div>
    </>
  );
};

export default UpgradeAnalytics;
